/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { appsApi } from '../api';
import { useAuth, useAlerts } from '../components/context';

import ApplicationCreateForm from '../components/applications/ApplicationCreateForm';
import Loader from '../components/common/Loader';
import { AppDetailHeader } from '../components/applications/AppProfileViewComponents';
import AppPanels from '../components/applications/AppPanels';

function Application({ isMobile }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { id } = useParams();
  const { user } = useAuth();
  const { setAlert } = useAlerts();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [app, setApp] = useState({});
  const redirect = () => {
    navigate({ pathname: '/apps', state: { from: location.pathname } });
  };

  const getApplication = async () => {
    try {
      const response = await appsApi.getApp(id);
      setApp({
        ...response.app,
        metrics: response.app.metrics,
      });
      setIsLoading(false);
    } catch (error) {
      redirect();
      setAlert({ message: error, variant: 'warning' });
    }
  };

  useEffect(() => {
    if (id !== 'new') {
      getApplication();
    }
  }, []);

  return (
    <Container className="main-content-container p-3 p-md-5 d-flex flex-column flex-grow-1">
      <AppDetailHeader t={t} />

      {id === 'new' ? (
        <ApplicationCreateForm onHide={redirect} isMobile={isMobile} />
      ) : isLoading ? (
        <Loader />
      ) : (
        <AppPanels
          app={app}
          t={t}
          setApp={setApp}
          onDelete={redirect}
          isMobile={isMobile}
          onSave={getApplication}
          user={user}
          onFreeze={getApplication}
        />
      )}
    </Container>
  );
}

export default Application;
